import { render, staticRenderFns } from "./promotionalImageManage.vue?vue&type=template&id=361b4b78&scoped=true&"
import script from "./promotionalImageManage.vue?vue&type=script&lang=ts&"
export * from "./promotionalImageManage.vue?vue&type=script&lang=ts&"
import style0 from "./promotionalImageManage.vue?vue&type=style&index=0&id=361b4b78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361b4b78",
  null
  
)

export default component.exports